import { connect } from 'react-redux';
import UploadKelas from '../../../views/Akademi/DataKelas/UploadKelas.view';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(UploadKelas);
